import { IFederalLottery } from '../../../interfaces';

class FederalLotteryMapper {
    toPersistence(domainLottery: IFederalLottery): any {
        return {
            id: domainLottery.id,
            result: domainLottery.result,
            raffle_date: domainLottery.raffle_date,
        }
    }

    toDomain(persistenceLottery: any): IFederalLottery {
        return {
            id: persistenceLottery.id,
            result: persistenceLottery.result,
            raffle_date: persistenceLottery.raffle_date,
            created_at: persistenceLottery.created_at,
            updated_at: persistenceLottery.updated_at
        }
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new FederalLotteryMapper();
